import { render } from "./MediaIcon.vue?vue&type=template&id=7eca9f4c"
import script from "./MediaIcon.vue?vue&type=script&lang=js"
export * from "./MediaIcon.vue?vue&type=script&lang=js"

import exportComponent from "/home/collin/workspace/hitech05/main-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__